import React from "react";
import { Typography } from "@material-ui/core";
import { Person } from "@material-ui/icons";
import { useTranslation } from "../../../hooks/useTranslation";
import "./ExitUsersHeader.css";

type ExitHeaderProps = {
  totalInside: number;
  capacity?: number;
};

const ExitHeader = ({ totalInside, capacity = 200 }: ExitHeaderProps) => {
  const { t, BundleKey } = useTranslation();

  return (
    <div className="headerContainer">
      <Typography variant="h4" className="complexTitle">
        {t(BundleKey.EXITCARD_PEOPLE_INSIDE)}
      </Typography>

      <div className="totalBadge">
        <div className="badgeCircle">
          <Person className="badgePersonIcon" />
        </div>
        <div className="totalPeople">
          <Typography className="peopleText" variant="h6">
            {t(BundleKey.EXITCARD_TOTAL_PEOPLE)}
          </Typography>
          <Typography className="peopleTextNumber" variant="h4">
            {totalInside}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default ExitHeader;
